import { render, staticRenderFns } from "./ProductGroupSelect.vue?vue&type=template&id=7624e8e7&"
import script from "./ProductGroupSelect.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports